export function FilterModalTitleIcon() {
  return (
    <svg fill="none" height="36" viewBox="0 0 30 36" width="30" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 29.25V6.75H15V11.75H27.5V29.25H2.5ZM5 26.75H7.5V24.25H5V26.75ZM5 21.75H7.5V19.25H5V21.75ZM5 16.75H7.5V14.25H5V16.75ZM5 11.75H7.5V9.25H5V11.75ZM10 26.75H12.5V24.25H10V26.75ZM10 21.75H12.5V19.25H10V21.75ZM10 16.75H12.5V14.25H10V16.75ZM10 11.75H12.5V9.25H10V11.75ZM15 26.75H25V14.25H15V16.75H17.5V19.25H15V21.75H17.5V24.25H15V26.75ZM20 19.25V16.75H22.5V19.25H20ZM20 24.25V21.75H22.5V24.25H20Z"
        fill="black"
      />
    </svg>
  )
}
